import React from "react";
import {Row, Table} from "antd";

import moment from "moment";
import {CreateCallRecordModal} from "./createCallRecordModal/CreateCallRecordModal";
import {courierCallStatusMap} from "../../../../../constants/constants";
import {ResponsiveTableContainer} from "./style/CourierCallRecorts.styled";

export const CourierCallRecords = ({courier, reloadCourier, loading}) => {
    const {callRecords = []} = courier;

    return (
        <>
            <CreateCallRecordModal
                courierId={courier?._id?.toString()}
                onComplete={reloadCourier}
                buttonSize="middle"
            />
            <ResponsiveTableContainer
                loading={loading}
                pagination={false}
                columns={[
                    {
                        title: "Arama Durumu",
                        render: (_, callRecord) => (
                            <Row align="middle">
                                {courierCallStatusMap[callRecord.callStatus] ||
                                    callRecord.callStatus}
                            </Row>
                        ),
                        onCell: () => ({
                            "data-label": "Arama Durumu"
                        })
                    },
                    {
                        title: "Arama Alt Durumu",
                        render: (_, callRecord) => (
                            <Row align="middle">{callRecord.callbackStatusTr || "-"}</Row>
                        ),
                        onCell: () => ({
                            "data-label": "Arama Alt Durumu"
                        })
                    },
                    {
                        title: "Arama Yapan",
                        render: (_, callRecord) => (
                            <Row align="middle">{callRecord.user.fullName}</Row>
                        ),
                        onCell: () => ({
                            "data-label": "Arama Yapan"
                        })
                    },
                    {
                        title: "Detay",
                        render: (_, callRecord) => (
                            <Row align="middle">{callRecord.comment || "-"}</Row>
                        ),
                        onCell: () => ({
                            "data-label": "Detay"
                        })
                    },
                    {
                        title: "Oluşturulma Tarihi",
                        render: (_, callRecord) => (
                            <Row align="middle">{moment(callRecord.createdAt).format("lll")}</Row>
                        ),
                        sorter: (a, b) => moment(a.createdAt).diff(moment(b.createdAt)),
                        onCell: () => ({
                            "data-label": "Oluşturulma Tarihi"
                        })
                    }
                ]}
                rowKey={record => record.id}
                dataSource={callRecords
                    .map(callRecord => ({
                        id: callRecord._id.toString(),
                        callStatus:
                            courierCallStatusMap[callRecord.callStatus] || callRecord.callStatus,
                        callbackStatusTr: callRecord.callbackStatusTr,
                        comment: callRecord.comment,
                        userId: callRecord.userId,
                        user: callRecord.user,
                        createdAt: callRecord.createdAt
                    }))
                    .sort((a, b) => moment(b.createdAt).diff(moment(a.createdAt)))}
            />
        </>
    );
};
